export const eventTypeColors = {
  1: 'red',
  2: 'green',
  3: 'yellow',
  4: 'blue',
  5: 'grape',
  6: 'orange',
  7: 'indigo',
  8: 'gray',
}
